import { useFormikContext } from "formik";
import { Checkbox } from "@volca/ui/components/ui/checkbox";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { IBusiness } from "@/business/business";
import { formatMoney } from "@/core/utils/money";
import BusinessInfoPair from "./business-info-pair";

const BusinessPaymentsSettings = ({ isEditMode }: { isEditMode: boolean }) => {
  const { values, setFieldValue } = useFormikContext<Partial<IBusiness>>();

  return (
    <Stack align="start" gap={4} className="w-full pb-6">
      <Text variant="title">Payment settings</Text>
      <Stack align="start" direction="row" gap={6} className="w-full flex-wrap">
        <BusinessInfoPair
          isEditMode={isEditMode}
          label="Maximum referral payout"
          value={formatMoney(values?.max_payout || 0)}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            void setFieldValue("max_payout", numericValue || 0);
          }}
        />
        <Stack
          align="start"
          gap={isEditMode ? 4 : 2}
          className="w-full sm:size-1/4"
        >
          <Stack direction="row" gap={2} align="center">
            {isEditMode && (
              <Checkbox
                checked={values.credit_payment_enabled}
                onCheckedChange={(checked) =>
                  setFieldValue("credit_payment_enabled", checked)
                }
              />
            )}
            <Text variant="label" tone="muted">
              Credit bonus available
            </Text>
          </Stack>
          {isEditMode ? (
            <Text variant="caption" tone="muted">
              Advocates and reps will be informed via email and the business can
              add the credit to their account
            </Text>
          ) : (
            <Text>{values.credit_payment_enabled ? "Yes" : "No"}</Text>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BusinessPaymentsSettings;
